import { useEffect, useRef, type InputHTMLAttributes, type Ref } from "react";
import "./checkbox.css";

type Props = Omit<InputHTMLAttributes<HTMLInputElement>, "type" | "checked" | "onChange" | "aria-label" | "children"> & {
  /** Il nome della casella per gli screen reader (non si vede: la riga o la colonna dicono già di che si tratta). */
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  /** A metà: alcune righe spuntate e altre no. Un clic la spunta (e `onChange` riceve `true`). */
  indeterminate?: boolean;
  /** Arriva all'`<input>` (in React 19 `ref` è una prop). */
  ref?: Ref<HTMLInputElement>;
};

// La sola casella, senza etichetta scritta accanto: per la selezione delle righe di una tabella. Quando l'etichetta
// si vede, si usa `Checkbox`.
export function CheckboxInput({ label, checked, onChange, indeterminate = false, className, ref, ...rest }: Props) {
  const own = useRef<HTMLInputElement | null>(null);
  useEffect(() => {
    if (own.current) own.current.indeterminate = indeterminate;
  }, [indeterminate]);
  return (
    <input
      {...rest}
      ref={(element) => {
        own.current = element;
        if (typeof ref === "function") ref(element);
        else if (ref) ref.current = element;
      }}
      type="checkbox"
      className={className ? `g-check__input ${className}` : "g-check__input"}
      aria-label={label}
      checked={checked}
      onChange={(event) => onChange(event.target.checked)}
    />
  );
}
